<template>
  <div class="mt-3" v-if="checkSheetImage">
    <div :id="`sheet_pole_${sheetType}_${pole._id}`" class="report sheet border rounded report-overview">
      <article :class="{ transparent: isLoading }">
        <div class="sheet-header">
          <div class="header-logo">
            <img :src="district.custom_logo.url" v-if="district && district.custom_logo && district.custom_logo.url" />
            <img src="@/assets/images/tnb-logo-report.png" v-else />
            <div class="header-title border-top">
              {{ filters.type }} Report
            </div>
          </div>
          <div class="header-info border-left">
            <div class="info-table">
              <div class="table-row border-bottom">
                <template v-if="category == 'lv'">
                  <div class="table-cell table-head border-right">
                    <p>FEEDER</p>
                  </div>
                  <div class="table-cell table-cell-long table-head border-right">
                    <p class="pl-1 text-uppercase">{{ feeder }}</p>
                  </div>
                </template>
                <template v-else>
                  <div class="table-cell table-head border-right">
                    <p>SOURCE</p>
                  </div>
                  <div class="table-cell table-cell-long table-head border-right">
                    <p class="pl-1 text-uppercase">{{ source }}</p>
                  </div>
                </template>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>POLE NO</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.name }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>DATE</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ dateFormat("date", pole.datetime) }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>TIME</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ dateFormat("time", pole.datetime) }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>POLE TYPE</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.type }} {{ pole.structure_type }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>VOLTAGE</p>
                </div>
                <div class="table-cell border-right">
                  <p>
                    {{
                      category == "lv"
                        ? `${voltage} V`
                        : `${voltage} kV`
                    }}
                  </p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>TEMP</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.ambient || temperature ? `${pole.ambient || temperature} °C` : "n/a" }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>LOAD</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ load ? `${load} A` : "UNKNOWN" }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>PHASE</p>
                </div>
                <div class="table-cell border-right">
                  <p>
                    {{ "ALL" }}
                  </p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>HUMIDITY</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.humidity || humidity ? `${pole.humidity || humidity} %` : "n/a" }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>COORDINATE</p>
                </div>
                <div class="table-cell table-cell-long border-right">
                  <p class="px-2">
                    {{ pole.lat ? pole.lat.toFixed(5) : "n/a" }},
                    {{ pole.lng ? pole.lng.toFixed(5) : "n/a" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-components"
          :class="{ 'sheet-components-visual': sheetType == 'visual', 'sheet-components-lv': category == 'lv' }">
          <div class="component-table">
            <div class="table-row table-row-head border-bottom">
              <div class="table-cell table-head text-center">
                <p>COMPONENT / EQUIPMENT</p>
              </div>
            </div>
            <template v-if="category === 'lv'">
              <div class="table-row border-bottom table-row-four">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>EARTHING</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>PHASE CONDUCTOR</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>INSULATED PEARCING CONNECTOR (IPC)</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>POLE</p>
                </div>
              </div>
              <div class="table-row border-bottom table-row-four">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>BLACK BOX</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>JUMPER</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead">
                  <p>CABLE TERMINATION</p>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="sheetType == 'visual' && pole.type == 'ABC'">
                <div class="table-row border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>TIANG</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>NO. TIANG / NOTIS BAHAYA</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>RENTIS</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENGALIR FASA</p>
                  </div>
                </div>
                <div class="table-row border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>UMBANG</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENEBAT UMBANG</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>EARTH BONDING</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>TAMATAN KABEL</p>
                  </div>
                </div>
                <div class="table-row border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>JOINT</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>CABLE TRAY</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENANGKAP KILAT</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>SWITCH LINK / LBS / AR</p>
                  </div>
                </div>
                <div class="table-row border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>SUSPENSION / DEAD END CLAMP</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>TRIANGULAR BRACKET</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>OTHERS</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>OBSERVATIONS</p>
                  </div>
                </div>
              </template>
              <template v-if="sheetType == 'visual' && pole.type != 'ABC'">
                <div class="table-row-alt border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>TIANG</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>NO. TIANG / NOTIS BAHAYA</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>RENTIS</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENGALIR FASA</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>UMBANG</p>
                  </div>
                </div>
                <div class="table-row-alt border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>SWITCH LINK / LBS / AR</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PEPALANG (CROSSARM)</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENGALIR BUMI</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>DAWAI KE BUMI (EARTH WIRE)</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>DISC INSULATOR</p>
                  </div>
                </div>
                <div class="table-row-alt border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PERANGKAP KILAT PADA TALIAN</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>JUMPER</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PG CLAMPS / CONNECTORS</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>ANTI CLIMBING DEVICE</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>ARCHING HORN</p>
                  </div>
                </div>
                <div class="table-row-alt border-bottom">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>LFI</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>EARTH CROSSARM</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>OTHERS</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>OBSERVATIONS</p>
                  </div>
                  <div class="table-cell bg-gray"></div>
                  <div class="table-cell table-subhead border-right bg-gray"></div>
                </div>
              </template>
              <template v-else-if="sheetType == 'thermal'">
                <div class="table-row border-bottom table-row-thermal">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENGALIR FASA</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>SWITCH LINK / LBS / AR</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENGALIR BUMI (SHIELD WIRE)</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>DAWAI KE BUMI (EARTH WIRE)</p>
                  </div>
                </div>
                <div class="table-row border-bottom table-row-thermal">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PENANGKAP KILAT PADA TALIAN</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>JUMPER</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>PG CLAMPS / CONNECTOR</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>ARCHING HORN</p>
                  </div>
                </div>
                <div class="table-row border-bottom table-row-thermal">
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>EARTH BONDING</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>TAMATAN KABEL</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>JOINT</p>
                  </div>
                  <div class="table-cell border-right">
                    <p class="position-relative text-center font-weight-bold"></p>
                  </div>
                  <div class="table-cell table-subhead border-right">
                    <p>OTHERS</p>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="sheet-images">
          <div class="images-table">
            <div class="table-row border-bottom">
              <div class="table-cell table-head w-100">
                <p v-if="sheetType == 'visual'" class="text-center">
                  VISUAL IMAGE
                </p>
                <p v-else-if="sheetType == 'thermal'" class="text-center">
                  THERMAL IMAGE
                </p>
              </div>
            </div>
            <div class="table-row row-images border-bottom">
              <div class="table-cell border-right text-center p-2">
                <div class="embed-responsive embed-responsive-4by3">
                  <div class="embed-responsive-item text-center">
                    <img class="clickable" :src="getImageUrl(0)" @click="toggleModal('galleryViewer', true, 0)"
                      v-if="getImageUrl(0)" />
                  </div>
                </div>
              </div>
              <div class="table-cell border-right text-center p-2">
                <div class="embed-responsive embed-responsive-4by3">
                  <div class="embed-responsive-item text-center">
                    <img class="clickable" :src="getImageUrl(1)" @click="toggleModal('galleryViewer', true, 1)"
                      v-if="getImageUrl(1)" />
                  </div>
                </div>
              </div>
            </div>
            <div class="table-row row-images border-bottom">
              <div class="table-cell border-right text-center p-2">
                <div class="embed-responsive embed-responsive-4by3">
                  <div class="embed-responsive-item text-center">
                    <img class="clickable" :src="getImageUrl(2)" @click="toggleModal('galleryViewer', true, 2)"
                      v-if="getImageUrl(2)" />
                  </div>
                </div>
              </div>
              <div class="table-cell border-right text-center p-2">
                <div class="embed-responsive embed-responsive-4by3">
                  <div class="embed-responsive-item text-center">
                    <img class="clickable" :src="getImageUrl(3)" @click="toggleModal('galleryViewer', true, 3)"
                      v-if="getImageUrl(3)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-remarks">
          <div class="remarks-table">
            <div class="table-row border-bottom">
              <div class="table-cell w-100 text-center">
                <p v-if="sheetType == 'visual'" class="font-weight-bolder">
                  VISUAL DEFECT
                </p>
                <p v-else-if="sheetType == 'thermal'" class="font-weight-bolder">
                  THERMAL DEFECT
                </p>
              </div>
            </div>
            <div class="table-row row-remarks border-bottom">
              <div class="table-cell table-cell-long w-100">
                <p>
                  {{ `No ${sheetType} problem detected` }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-recommendations">
          <div class="recommendations-table">
            <div class="table-row border-bottom">
              <div class="table-cell w-100 text-center">
                <p class="font-weight-bolder">
                  ANALYSIS &amp; RECOMMENDATION
                </p>
              </div>
            </div>
            <div class="table-row row-recommendations">
              <div class="table-cell w-100">
                <p v-if="sheetType == 'visual'">
                  {{ pole.visual_remark }}
                </p>
                <p v-else-if="sheetType == 'thermal'">
                  {{ pole.thermal_remark }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
      <loading-spinner class="loading-spinner-component" v-if="isLoading"></loading-spinner>
    </div>
    <!-- <div class="page-break"></div> -->
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reportSheet",
  props: [
    "district",
    "source",
    "feeder",
    "category",
    "pole",
    "date",
    "filters",
    "voltage",
    "load",
    "temperature",
    "humidity",
    "sheetType",
  ],
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      visualImages: [],
      thermalImages: [],
    };
  },
  watch: {
    pole: {
      async handler() {
        if (this.pole) {
          this.resizeOverviewSheet();
          await this.fetchDefectImages();
        }
      },
      immediate: true,
    },
  },
  computed: {
    checkSheetImage() {
      // if (this.sheetType !== 'visual') return true;
      // else return this[`${this.sheetType}Images`]?.length || 0;

      return this[`${this.sheetType}Images`]?.length || 0;
    }
  },
  methods: {
    toggleModal(modalName, show, index) {
      if (show) {
        if (modalName === "galleryViewer" && this.getImageUrl(index)) {
          let galleryImageIndex = index;
          let galleryImages = this[`${this.sheetType}Images`].map((vi) =>
            vi.url && vi.url.substring(0, 4) == "http"
              ? vi.url
              : "https://".concat(vi.url)
          );
          this.$emit(
            "toggleModal",
            modalName,
            show,
            galleryImages,
            galleryImageIndex,
            this.sheetType == 'thermal' ? this.pole.thermal_remark : this.pole.visual_remark
          );
        }
      }
    },
    getImageUrl(index) {
      let imageUrl = this[`${this.sheetType}Images`][index];

      if (imageUrl) {
        return imageUrl.url && imageUrl.url.substring(0, 4) == "http"
          ? imageUrl.url
          : "https://".concat(imageUrl.url);
      } else {
        return null;
      }
    },
    async fetchDefectImages() {
      this.visualImages =
        this.pole.visualimage && this.pole.visualimage.length > 0
          ? this.pole.visualimage.sort((a, b) => {
            let aName = a.name ? a.name.toLowerCase() : null;
            let bName = b.name ? b.name.toLowerCase() : null;

            return aName < bName ? -1 : 1;
          })
          : [];
      this.thermalImages =
        this.pole.thermalimages && this.pole.thermalimages.length > 0
          ? this.pole.thermalimages.sort((a, b) => {
            let aName = a.name ? a.name.toLowerCase() : null;
            let bName = b.name ? b.name.toLowerCase() : null;

            return aName < bName ? -1 : 1;
          })
          : [];
    },
    dateFormat(type, date) {
      if (date) {
        if (type === "date") {
          return moment.utc(date).format("DD/MM/YYYY");
        } else if (type === "time") {
          return moment.utc(date).format("h:mm A");
        } else {
          return date;
        }
      } else {
        return "";
      }
    },
    resizeOverviewSheet(skipTimeout) {
      this.isLoading = skipTimeout ? false : true;
      setTimeout(
        () => {
          let elementId = `#sheet_pole_${this.sheetType}_${this.pole._id}`;
          const sheet = $(elementId);
          const sheetWidth = sheet.width();
          sheet.height(sheetWidth * 1.2414285714);
          sheet.css({
            fontSize: sheetWidth * 0.01026119403,
          });
          const title = sheet
            .children()
            .children()
            .children()
            .children(".header-title");
          title.css({
            fontSize: sheetWidth * 0.01679104478,
          });
          this.isLoading = false;
        },
        skipTimeout ? 10 : 2000
      );
    },
  },
  mounted() {
    $(window).on("resize", (e) => {
      this.resizeOverviewSheet(true);
    });
  },
  beforeDestroy() {
    $(window).off("resize");
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/print.scss");

.bg-gray {
  background-color: #f5f7fa !important;
}

.sheet {
  width: 100% !important;
  height: auto;
  position: relative;

  article {
    width: 100%;
    height: 100%;
    display: block;

    &.transparent {
      opacity: 0;
    }

    .sheet-header {
      height: 10%;

      .header-logo {
        display: inline-block;
        vertical-align: top;
        width: 20%;
        height: 100%;
        position: relative;
        text-align: center;

        img {
          width: 95%;
          height: 73%;
          padding: 5px;
          object-fit: contain;
        }

        .header-title {
          height: 27%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          text-transform: uppercase;
        }
      }

      .header-info {
        display: inline-block;
        vertical-align: top;
        width: 80%;
        height: 100%;

        .info-table {
          width: 100%;
          height: 100%;

          .table-row {
            height: 20%;

            .table-cell {
              width: 16.666666667%;

              &.table-cell-long {
                width: 83.333333333%;
              }
            }
          }
        }
      }
    }

    .sheet-components {
      height: 8%;

      &.sheet-components-visual {
        height: 10%;

        .table-row {
          &.table-row-head {
            height: 25% !important;
          }
        }
      }

      &.sheet-components-lv {
        .table-row {
          &.table-row-four {
            height: 35% !important;

            .table-cell.table-subhead {
              width: 20%;
            }
          }


          &.table-row-thermal {
            height: 35% !important;

            .table-cell.table-subhead {
              width: 28.33%;
            }
          }
        }
      }

      .component-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 18.75%;

          &.table-row-head {
            height: 30%;
          }

          &.table-row-thermal {
            height: 23.333333333%;
          }

          .table-cell {
            width: 5%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 20%;
            }
          }
        }

        .table-row-alt {
          height: 20%;

          &.table-row-thermal {
            height: 23.333333333%;
          }

          .table-cell {
            width: 3%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 17%;
            }
          }
        }
      }
    }

    .sheet-images {
      height: 63.5%;

      .images-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 4%;

          &.row-images {
            height: fit-content;
          }

          .table-cell {
            width: 50%;
          }
        }
      }
    }

    .sheet-remarks {
      height: 9%;

      .remarks-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-remarks {
            height: 75%;
          }

          .table-cell {
            width: 20%;

            &.table-cell-long {
              width: 80%;
            }

            .inner-row {
              width: 100%;
              height: 33.5%;
              position: relative;

              &:nth-child(odd) {
                height: 33.25%;
              }

              .inner-cell {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 25%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }

              .inner-cell-long {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 75%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }
            }
          }
        }
      }
    }

    .sheet-recommendations {
      height: 9.5%;

      .recommendations-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-recommendations {
            height: 75%;
          }
        }
      }
    }

    .table-cell {
      position: relative;
      display: inline-block;
      vertical-align: top;
      padding: 0px 1%;
      height: 100%;

      p {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        line-height: 110%;
        width: 100%;
        padding: 0px 3%;
      }

      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: contain;
      }
    }

    .table-head {
      color: #ffffff;
      background-color: #004c9c;
      font-weight: 500;
    }

    .table-subhead {
      background-color: #bdd7ee;
    }
  }
}
</style>
